import { useEffect } from 'react'
import { ILoanerRecord } from '../LoanerVehicles'

export const useSaveOnEnter = (
  activeLoaners: ILoanerRecord[],
  onSave: (loanerId: string) => void
) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        const editingLoaner = activeLoaners.find((loaner) => loaner.isEditing)
        if (editingLoaner) {
          onSave(editingLoaner.id)
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [activeLoaners, onSave])
}